<template>
  <div
    class="ms-textarea ms-editor"
    :class="{
      error: errorProvider.isValid,
      disabled: disabled,
      [ControlValidateClass]: isValidate,
    }"
  >
    <label v-if="label" class="label">{{ label }}</label>

    <div
      class="flex-row border"
      :class="{ error: errorMessage, disabled: disabled }"
    >
      <textarea
        v-if="trimModel"
        ref="input"
        v-model.trim="internalText"
        :class="[
          'ms-textarea-item flex',
          { 'ms-textarea-item-auto-height': isAutoHeight },
        ]"
        :placeholder="placeholder"
        :disabled="disabled"
        :maxlength="maxLength"
        :rows="rows"
        :readOnly="readOnly"
        :style="styleCustom"
        v-on="listeners"
      />
      <textarea
        v-else
        ref="input"
        v-model="internalText"
        :class="[
          'ms-textarea-item flex',
          { 'ms-textarea-item-auto-height': isAutoHeight },
        ]"
        :placeholder="placeholder"
        :disabled="disabled"
        :maxlength="maxLength"
        :rows="rows"
        :readOnly="readOnly"
        :style="styleCustom"
        v-on="listeners"
      />
    </div>

    <div v-if="errorMessage" class="error-text">
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import {
  useValidateControl,
  ControlValidateClass,
} from '@/setup/validateControl.js';
import { ref } from '@vue/reactivity';

export default {
  name: 'MsTextarea',
  extends: msBaseComponent,
  props: {
    styleCustom: {
      default: null,
      type: String,
    },
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    modelValue: {
      type: String,
      default: '',
    },
    /**
     * Có tự động tăng độ cao dựa vào nội dung bên trong ko
     */
    isAutoHeight: {
      type: Boolean,
      default: false,
    },
    /**
     * Chiều cao mặc định của input dùng khi isAutoHeight = true
     */
    defaultHeight: {
      type: [Number, String],
      default: 'unset',
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    placeholder: {
      default: null,
      type: [Number, String],
    },
    //class chứa icon
    icon: {
      default: null,
      type: String,
    },
    /**
     * Số dòng
     */
    rows: {
      default: 4,
      type: Number,
    },
    //ĐVThi 09/03/2021:  bổ sung Giới hạn nhập của ô input của TextArea
    maxLength: {
      default: null,
      type: Number,
    },
    trimModel: {
      default: true,
      type: Boolean,
    },
  },
  emits: ['change', 'update:modelValue'],
  setup(props) {
    const input = ref(null);

    const {
      errorMessage,
      validate,
      validated,
      focusError,
      isValidate,
    } = useValidateControl({ props }, input);

    /**
     * Lấy value của control
     * @author: BMThang(14/11/2022)
     */
    const getValue = () => {
      return props.modelValue;
    };

    return {
      errorMessage,
      validate,
      validated,
      focusError,
      isValidate,
      input,
      ControlValidateClass,
      getValue,
    };
  },
  data() {
    return {
      // Giá trị hiện tại của textarea
      internalText: this.modelValue,
      calHeightTimeout: null,
    };
  },
  computed: {
    /**
     * Binding event
     * @author: BMThang(04/12/2022)
     */
    listeners() {
      return {
        blur: (e) => {
          this.onBlur(e);
        },
        change: (e) => {
          this.$emit('change', this.internalText, e);
        },
        focus: (e) => {
          this.onFocus(e);
        },
      };
    },
  },
  watch: {
    internalText: {
      handler(newVal, oldVal) {
        const me = this;
        me.$emit('update:modelValue', newVal);
        me.$nextTick(() => {
          this.calHeight();
        });
      },
    },
    modelValue: {
      immediate: true,
      handler(newVal, oldVal) {
        const me = this;
        me.setValue(newVal);
      },
    },
  },
  mounted() {
    clearTimeout(this.calHeightTimeout);
    this.calHeightTimeout = setTimeout(() => {
      this.calHeight();
    }, 50);
  },
  unmounted() {
    clearTimeout(this.calHeightTimeout);
  },
  methods: {
    /**
     * Tính độ cao textarea khi isAutoHeight = true
     * @author: BMThang(14/01/2022)
     */
    calHeight() {
      // Nếu cho phép điều chỉnh độ cao tự động theo content thì điều chỉnh độ cao
      if (this.$refs.input && this.isAutoHeight) {
        this.$refs.input.style.height =
          typeof this.defaultHeight === 'number'
            ? `${this.defaultHeight}px`
            : this.defaultHeight;
        const newHeight = this.$refs.input.scrollHeight;
        this.$refs.input.style.height = `${parseInt(newHeight)}px`;
      }
    },

    //Sự kiên blur ra ngoài ô input
    onBlur(e) {
      const me = this;
      // Chỉ validate nếu đã validate 1 lần và đc validate
      if (me.validated && me.isValidate) {
        me.validate();
      }
    },
    //Sự kiện focus vào ô input
    onFocus(e) {
      const me = this;
    },
    //Reset lại giá trị về ban đầu
    reset() {
      const me = this;
      me.internalText = null;
    },
    //Set giá trị cho ô input
    setValue(value) {
      const me = this;
      me.internalText = value;
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/components/MsTextArea.scss';
</style>
